import { ref, computed, watch, type ComputedRef } from 'vue'
import { getUserProfile, getUserToken, getUserInfo } from '@streampac.io/chef_sp_1'
import { useAuthenticationData } from './useAuthenticationData'

import { type IUserData, type IUserDataProfile } from '@/types/UserData'

const isAuthenticated = computed(() => useAuthenticationData().data.value.isAuthenticated)

const currentUser = ref({})
const currentUserProfile = ref({})

export interface useCurrentUserDataModule {
  getCurrentUser: ComputedRef
  getCurrentUserProfile: ComputedRef
  refreshUserData(): void
}

let runOnce = false

export const useCurrentUserData: () => useCurrentUserDataModule = () => {
  const getData = (token: string) => {
    getUserInfo(token).then((userInfoResponse: IUserData) => {
      currentUser.value = userInfoResponse

      getUserProfile(token).then((userProfileResponse: IUserDataProfile) => {
        currentUserProfile.value = userProfileResponse
      })
    })
  }

  if (isAuthenticated.value && !runOnce) {
    getUserToken((token: string) => {
      getData(token)
      runOnce = true
    })
  }

  const refreshUserData = () => {
    //Reset data -> fix later
    currentUser.value = null
    currentUserProfile.value = null

    //retrieve latest data
    if (isAuthenticated.value) {
      getUserToken((token: string) => {
        getData(token)
      })
    }
  }

  const getCurrentUser = computed(() => currentUser.value || null)
  const getCurrentUserProfile = computed(() => currentUserProfile.value || null)

  return {
    getCurrentUser,
    getCurrentUserProfile,
    refreshUserData
  }
}
